<template lang="html">
    <div class="content-risk-messages">
        <ds-inline-alert
            v-if="showMessages"
            :type="alertType"
            :leading-icon="leadingIcon"
            class="content-risk-messages-alert"
            data-qa="content-risks-inline-alert"
        >
            <template #trailing>
                <ds-icon-button
                    v-if="collapsible"
                    :name="collapseButtonIcon"
                    data-qa="expand-button"
                    aria-label="Expand"
                    @click="expandMessages = !expandMessages"
                />
            </template>

            <template #default>
                <div class="description">
                    <slot />
                </div>
            </template>

            <template #footer>
                <ul
                    v-show="!collapsible || (collapsible && expandMessages)"
                    class="messages"
                    data-qa="messages-list"
                >
                    <li v-for="({ message }, i) in messages" :key="i">
                        {{ message }}
                    </li>
                </ul>
            </template>
        </ds-inline-alert>
    </div>
</template>

<script>
import { CONTENT_RISK_QUALITY } from './content-risk.constants';

export default {
    name: 'ContentRiskMessages',

    props: {
        quality: {
            type: String,
            options: [CONTENT_RISK_QUALITY.OK, CONTENT_RISK_QUALITY.WARN, CONTENT_RISK_QUALITY.SPAM_NOT_SENDABLE],
            required: true,
        },

        messages: {
            type: Array,
            default: () => [],
        },

        collapsible: Boolean,
    },

    data() {
        return {
            expandMessages: false,
        };
    },

    computed: {
        alertType() {
            switch (this.quality) {
            case CONTENT_RISK_QUALITY.WARN:
                return 'warning';
            case CONTENT_RISK_QUALITY.SPAM_NOT_SENDABLE:
                return 'critical';
            default:
                return 'ok';
            }
        },

        collapseButtonIcon() {
            return this.expandMessages ? 'chevron-up' : 'chevron-down';
        },

        leadingIcon() {
            switch (this.quality) {
            case CONTENT_RISK_QUALITY.WARN:
                return 'alert-triangle';
            case CONTENT_RISK_QUALITY.SPAM_NOT_SENDABLE:
                return 'alert-octagon';
            default:
                return 'checkmark';
            }
        },

        showMessages() {
            return [CONTENT_RISK_QUALITY.WARN, CONTENT_RISK_QUALITY.SPAM_NOT_SENDABLE].includes(this.quality);
        },
    },

};
</script>

<style lang="scss" scoped>
    .content-risk-messages-alert {
        width: 100%;
    }

    .description {
        font-size: $font-size-sm;
        margin: 0;
    }

    .messages {
        font-size: $font-size-sm;
        margin-top: $spacing-100;
        padding-left: $spacing-100;

        li {
            list-style-type: disc;
            @include margin-start($spacing-200);
        }
    }
</style>
